/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TrainerRouteImport } from './routes/trainer'
import { Route as OrgRouteImport } from './routes/org'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as StudentRouteImport } from './routes/_student'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TrainerIndexRouteImport } from './routes/trainer/index'
import { Route as ProfileIndexRouteImport } from './routes/profile/index'
import { Route as OrgIndexRouteImport } from './routes/org/index'
import { Route as MessagesIndexRouteImport } from './routes/messages/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as TrainerSettingsRouteImport } from './routes/trainer/settings'
import { Route as TrainerQuestionsRouteImport } from './routes/trainer/questions'
import { Route as TrainerDashboardRouteImport } from './routes/trainer/dashboard'
import { Route as TrainerAnalyticsRouteImport } from './routes/trainer/analytics'
import { Route as OrgSupportRouteImport } from './routes/org/support'
import { Route as OrgStudentsRouteImport } from './routes/org/students'
import { Route as OrgSettingsRouteImport } from './routes/org/settings'
import { Route as OrgReadinessRouteImport } from './routes/org/readiness'
import { Route as OrgMessagesRouteImport } from './routes/org/messages'
import { Route as OrgCompanyReadinessRouteImport } from './routes/org/company-readiness'
import { Route as AuthSetupRouteImport } from './routes/auth/setup'
import { Route as AuthResetPasswordRouteImport } from './routes/auth/reset-password'
import { Route as AuthOauthCallbackRouteImport } from './routes/auth/oauth-callback'
import { Route as AuthForgotPasswordRouteImport } from './routes/auth/forgot-password'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminTrainerFeedbackRouteImport } from './routes/admin/trainer-feedback'
import { Route as AdminStudentFeedbackRouteImport } from './routes/admin/student-feedback'
import { Route as AdminSettingsRouteImport } from './routes/admin/settings'
import { Route as AdminDashboardRouteImport } from './routes/admin/dashboard'
import { Route as AdminAnalyticsRouteImport } from './routes/admin/analytics'
import { Route as StudentSettingsRouteImport } from './routes/_student/settings'
import { Route as StudentHelpRouteImport } from './routes/_student/help'
import { Route as TrainerProblemsIndexRouteImport } from './routes/trainer/problems/index'
import { Route as TrainerBatchesIndexRouteImport } from './routes/trainer/batches/index'
import { Route as OrgBatchesIndexRouteImport } from './routes/org/batches/index'
import { Route as AdminProblemsIndexRouteImport } from './routes/admin/problems.index'
import { Route as AdminOrgsIndexRouteImport } from './routes/admin/orgs.index'
import { Route as AdminCurriculumIndexRouteImport } from './routes/admin/curriculum/index'
import { Route as AdminBatchesIndexRouteImport } from './routes/admin/batches.index'
import { Route as StudentScheduleIndexRouteImport } from './routes/_student/schedule/index'
import { Route as StudentProgressIndexRouteImport } from './routes/_student/progress/index'
import { Route as StudentProblemsIndexRouteImport } from './routes/_student/problems/index'
import { Route as StudentLeaderboardIndexRouteImport } from './routes/_student/leaderboard/index'
import { Route as StudentHackathonsIndexRouteImport } from './routes/_student/hackathons/index'
import { Route as StudentCoursesIndexRouteImport } from './routes/_student/courses/index'
import { Route as StudentContestsIndexRouteImport } from './routes/_student/contests/index'
import { Route as TrainerProblemsNewRouteImport } from './routes/trainer/problems/new'
import { Route as TrainerProblemsProblemIdRouteImport } from './routes/trainer/problems/$problemId'
import { Route as TrainerBatchesBatchIdRouteImport } from './routes/trainer/batches/$batchId'
import { Route as AdminProblemsNewRouteImport } from './routes/admin/problems.new'
import { Route as AdminProblemsProblemIdRouteImport } from './routes/admin/problems.$problemId'
import { Route as AdminOrgsNewRouteImport } from './routes/admin/orgs.new'
import { Route as AdminOrgsOrgIdRouteImport } from './routes/admin/orgs.$orgId'
import { Route as AdminCurriculumTemplateIdRouteImport } from './routes/admin/curriculum/$templateId'
import { Route as AdminBatchesBatchIdRouteImport } from './routes/admin/batches.$batchId'
import { Route as StudentProblemsSlugRouteImport } from './routes/_student/problems/$slug'
import { Route as StudentHackathonsHackathonIdRouteImport } from './routes/_student/hackathons/$hackathonId'
import { Route as TrainerBatchesBatchIdIndexRouteImport } from './routes/trainer/batches/$batchId/index'
import { Route as OrgBatchesBatchIdIndexRouteImport } from './routes/org/batches/$batchId.index'
import { Route as AdminBatchesBatchIdIndexRouteImport } from './routes/admin/batches.$batchId.index'
import { Route as StudentCoursesBatchIdIndexRouteImport } from './routes/_student/courses/$batchId/index'
import { Route as TrainerBatchesBatchIdStudentsRouteImport } from './routes/trainer/batches/$batchId/students'
import { Route as TrainerBatchesBatchIdSessionsRouteImport } from './routes/trainer/batches/$batchId/sessions'
import { Route as TrainerBatchesBatchIdOverviewRouteImport } from './routes/trainer/batches/$batchId/overview'
import { Route as TrainerBatchesBatchIdGradingRouteImport } from './routes/trainer/batches/$batchId/grading'
import { Route as TrainerBatchesBatchIdCurriculumRouteImport } from './routes/trainer/batches/$batchId/curriculum'
import { Route as TrainerBatchesBatchIdAttentionRouteImport } from './routes/trainer/batches/$batchId/attention'
import { Route as TrainerBatchesBatchIdAnnouncementsRouteImport } from './routes/trainer/batches/$batchId/announcements'
import { Route as AdminBatchesBatchIdEnrollmentRouteImport } from './routes/admin/batches.$batchId.enrollment'
import { Route as AdminBatchesBatchIdCurriculumRouteImport } from './routes/admin/batches.$batchId.curriculum'
import { Route as StudentCoursesBatchIdLearnRouteImport } from './routes/_student/courses/$batchId/learn'
import { Route as TrainerBatchesBatchIdHackathonsIndexRouteImport } from './routes/trainer/batches/$batchId/hackathons/index'
import { Route as AdminBatchesBatchIdHackathonsIndexRouteImport } from './routes/admin/batches.$batchId.hackathons.index'
import { Route as StudentCoursesBatchIdPracticeIndexRouteImport } from './routes/_student/courses/$batchId/practice/index'
import { Route as TrainerBatchesBatchIdWorkItemsAssessmentIdRouteImport } from './routes/trainer/batches/$batchId/work-items.$assessmentId'
import { Route as TrainerBatchesBatchIdHackathonsHackathonIdRouteImport } from './routes/trainer/batches/$batchId/hackathons/$hackathonId'
import { Route as OrgBatchesBatchIdWorkItemsAssessmentIdRouteImport } from './routes/org/batches/$batchId.work-items.$assessmentId'
import { Route as OrgBatchesBatchIdStudentsUserIdRouteImport } from './routes/org/batches/$batchId.students.$userId'
import { Route as OrgBatchesBatchIdSessionsSessionIdRouteImport } from './routes/org/batches/$batchId.sessions.$sessionId'
import { Route as OrgBatchesBatchIdAssignmentsAssignmentIdRouteImport } from './routes/org/batches/$batchId.assignments.$assignmentId'
import { Route as OrgBatchesBatchIdAssessmentsAssessmentIdRouteImport } from './routes/org/batches/$batchId.assessments.$assessmentId'
import { Route as AdminBatchesBatchIdHackathonsHackathonIdRouteImport } from './routes/admin/batches.$batchId.hackathons.$hackathonId'
import { Route as StudentCoursesBatchIdTopicsTopicIdRouteImport } from './routes/_student/courses/$batchId/topics/$topicId'
import { Route as StudentCoursesBatchIdTopicsTopicIdIndexRouteImport } from './routes/_student/courses/$batchId/topics/$topicId/index'
import { Route as StudentCoursesBatchIdPracticeCategoryIndexRouteImport } from './routes/_student/courses/$batchId/practice/$category/index'
import { Route as StudentCoursesBatchIdTopicsTopicIdResourcesRouteImport } from './routes/_student/courses/$batchId/topics/$topicId/resources'
import { Route as StudentCoursesBatchIdTopicsTopicIdRecordingRouteImport } from './routes/_student/courses/$batchId/topics/$topicId/recording'
import { Route as StudentCoursesBatchIdTopicsTopicIdPracticeRouteImport } from './routes/_student/courses/$batchId/topics/$topicId/practice'
import { Route as StudentCoursesBatchIdTopicsTopicIdNotesRouteImport } from './routes/_student/courses/$batchId/topics/$topicId/notes'
import { Route as StudentCoursesBatchIdTopicsTopicIdFeedbackRouteImport } from './routes/_student/courses/$batchId/topics/$topicId/feedback'
import { Route as StudentCoursesBatchIdTopicsTopicIdAskTrainerRouteImport } from './routes/_student/courses/$batchId/topics/$topicId/ask-trainer'
import { Route as StudentCoursesBatchIdPracticeCategoryAssessmentIdRouteImport } from './routes/_student/courses/$batchId/practice/$category/$assessmentId'
import { Route as StudentCoursesBatchIdTopicsTopicIdQuizAssessmentIdRouteImport } from './routes/_student/courses/$batchId/topics/$topicId_/quiz.$assessmentId'

const TrainerRoute = TrainerRouteImport.update({
  id: '/trainer',
  path: '/trainer',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgRoute = OrgRouteImport.update({
  id: '/org',
  path: '/org',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const StudentRoute = StudentRouteImport.update({
  id: '/_student',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TrainerIndexRoute = TrainerIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TrainerRoute,
} as any)
const ProfileIndexRoute = ProfileIndexRouteImport.update({
  id: '/profile/',
  path: '/profile/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgIndexRoute = OrgIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrgRoute,
} as any)
const MessagesIndexRoute = MessagesIndexRouteImport.update({
  id: '/messages/',
  path: '/messages/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const TrainerSettingsRoute = TrainerSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => TrainerRoute,
} as any)
const TrainerQuestionsRoute = TrainerQuestionsRouteImport.update({
  id: '/questions',
  path: '/questions',
  getParentRoute: () => TrainerRoute,
} as any)
const TrainerDashboardRoute = TrainerDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => TrainerRoute,
} as any)
const TrainerAnalyticsRoute = TrainerAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => TrainerRoute,
} as any)
const OrgSupportRoute = OrgSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => OrgRoute,
} as any)
const OrgStudentsRoute = OrgStudentsRouteImport.update({
  id: '/students',
  path: '/students',
  getParentRoute: () => OrgRoute,
} as any)
const OrgSettingsRoute = OrgSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => OrgRoute,
} as any)
const OrgReadinessRoute = OrgReadinessRouteImport.update({
  id: '/readiness',
  path: '/readiness',
  getParentRoute: () => OrgRoute,
} as any)
const OrgMessagesRoute = OrgMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => OrgRoute,
} as any)
const OrgCompanyReadinessRoute = OrgCompanyReadinessRouteImport.update({
  id: '/company-readiness',
  path: '/company-readiness',
  getParentRoute: () => OrgRoute,
} as any)
const AuthSetupRoute = AuthSetupRouteImport.update({
  id: '/auth/setup',
  path: '/auth/setup',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/auth/reset-password',
  path: '/auth/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthOauthCallbackRoute = AuthOauthCallbackRouteImport.update({
  id: '/auth/oauth-callback',
  path: '/auth/oauth-callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/auth/forgot-password',
  path: '/auth/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminTrainerFeedbackRoute = AdminTrainerFeedbackRouteImport.update({
  id: '/trainer-feedback',
  path: '/trainer-feedback',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStudentFeedbackRoute = AdminStudentFeedbackRouteImport.update({
  id: '/student-feedback',
  path: '/student-feedback',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDashboardRoute = AdminDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AdminRoute,
} as any)
const StudentSettingsRoute = StudentSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => StudentRoute,
} as any)
const StudentHelpRoute = StudentHelpRouteImport.update({
  id: '/help',
  path: '/help',
  getParentRoute: () => StudentRoute,
} as any)
const TrainerProblemsIndexRoute = TrainerProblemsIndexRouteImport.update({
  id: '/problems/',
  path: '/problems/',
  getParentRoute: () => TrainerRoute,
} as any)
const TrainerBatchesIndexRoute = TrainerBatchesIndexRouteImport.update({
  id: '/batches/',
  path: '/batches/',
  getParentRoute: () => TrainerRoute,
} as any)
const OrgBatchesIndexRoute = OrgBatchesIndexRouteImport.update({
  id: '/batches/',
  path: '/batches/',
  getParentRoute: () => OrgRoute,
} as any)
const AdminProblemsIndexRoute = AdminProblemsIndexRouteImport.update({
  id: '/problems/',
  path: '/problems/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrgsIndexRoute = AdminOrgsIndexRouteImport.update({
  id: '/orgs/',
  path: '/orgs/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCurriculumIndexRoute = AdminCurriculumIndexRouteImport.update({
  id: '/curriculum/',
  path: '/curriculum/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminBatchesIndexRoute = AdminBatchesIndexRouteImport.update({
  id: '/batches/',
  path: '/batches/',
  getParentRoute: () => AdminRoute,
} as any)
const StudentScheduleIndexRoute = StudentScheduleIndexRouteImport.update({
  id: '/schedule/',
  path: '/schedule/',
  getParentRoute: () => StudentRoute,
} as any)
const StudentProgressIndexRoute = StudentProgressIndexRouteImport.update({
  id: '/progress/',
  path: '/progress/',
  getParentRoute: () => StudentRoute,
} as any)
const StudentProblemsIndexRoute = StudentProblemsIndexRouteImport.update({
  id: '/problems/',
  path: '/problems/',
  getParentRoute: () => StudentRoute,
} as any)
const StudentLeaderboardIndexRoute = StudentLeaderboardIndexRouteImport.update({
  id: '/leaderboard/',
  path: '/leaderboard/',
  getParentRoute: () => StudentRoute,
} as any)
const StudentHackathonsIndexRoute = StudentHackathonsIndexRouteImport.update({
  id: '/hackathons/',
  path: '/hackathons/',
  getParentRoute: () => StudentRoute,
} as any)
const StudentCoursesIndexRoute = StudentCoursesIndexRouteImport.update({
  id: '/courses/',
  path: '/courses/',
  getParentRoute: () => StudentRoute,
} as any)
const StudentContestsIndexRoute = StudentContestsIndexRouteImport.update({
  id: '/contests/',
  path: '/contests/',
  getParentRoute: () => StudentRoute,
} as any)
const TrainerProblemsNewRoute = TrainerProblemsNewRouteImport.update({
  id: '/problems/new',
  path: '/problems/new',
  getParentRoute: () => TrainerRoute,
} as any)
const TrainerProblemsProblemIdRoute =
  TrainerProblemsProblemIdRouteImport.update({
    id: '/problems/$problemId',
    path: '/problems/$problemId',
    getParentRoute: () => TrainerRoute,
  } as any)
const TrainerBatchesBatchIdRoute = TrainerBatchesBatchIdRouteImport.update({
  id: '/batches/$batchId',
  path: '/batches/$batchId',
  getParentRoute: () => TrainerRoute,
} as any)
const AdminProblemsNewRoute = AdminProblemsNewRouteImport.update({
  id: '/problems/new',
  path: '/problems/new',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProblemsProblemIdRoute = AdminProblemsProblemIdRouteImport.update({
  id: '/problems/$problemId',
  path: '/problems/$problemId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrgsNewRoute = AdminOrgsNewRouteImport.update({
  id: '/orgs/new',
  path: '/orgs/new',
  getParentRoute: () => AdminRoute,
} as any)
const AdminOrgsOrgIdRoute = AdminOrgsOrgIdRouteImport.update({
  id: '/orgs/$orgId',
  path: '/orgs/$orgId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCurriculumTemplateIdRoute =
  AdminCurriculumTemplateIdRouteImport.update({
    id: '/curriculum/$templateId',
    path: '/curriculum/$templateId',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminBatchesBatchIdRoute = AdminBatchesBatchIdRouteImport.update({
  id: '/batches/$batchId',
  path: '/batches/$batchId',
  getParentRoute: () => AdminRoute,
} as any)
const StudentProblemsSlugRoute = StudentProblemsSlugRouteImport.update({
  id: '/problems/$slug',
  path: '/problems/$slug',
  getParentRoute: () => StudentRoute,
} as any)
const StudentHackathonsHackathonIdRoute =
  StudentHackathonsHackathonIdRouteImport.update({
    id: '/hackathons/$hackathonId',
    path: '/hackathons/$hackathonId',
    getParentRoute: () => StudentRoute,
  } as any)
const TrainerBatchesBatchIdIndexRoute =
  TrainerBatchesBatchIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => TrainerBatchesBatchIdRoute,
  } as any)
const OrgBatchesBatchIdIndexRoute = OrgBatchesBatchIdIndexRouteImport.update({
  id: '/batches/$batchId/',
  path: '/batches/$batchId/',
  getParentRoute: () => OrgRoute,
} as any)
const AdminBatchesBatchIdIndexRoute =
  AdminBatchesBatchIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AdminBatchesBatchIdRoute,
  } as any)
const StudentCoursesBatchIdIndexRoute =
  StudentCoursesBatchIdIndexRouteImport.update({
    id: '/courses/$batchId/',
    path: '/courses/$batchId/',
    getParentRoute: () => StudentRoute,
  } as any)
const TrainerBatchesBatchIdStudentsRoute =
  TrainerBatchesBatchIdStudentsRouteImport.update({
    id: '/students',
    path: '/students',
    getParentRoute: () => TrainerBatchesBatchIdRoute,
  } as any)
const TrainerBatchesBatchIdSessionsRoute =
  TrainerBatchesBatchIdSessionsRouteImport.update({
    id: '/sessions',
    path: '/sessions',
    getParentRoute: () => TrainerBatchesBatchIdRoute,
  } as any)
const TrainerBatchesBatchIdOverviewRoute =
  TrainerBatchesBatchIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => TrainerBatchesBatchIdRoute,
  } as any)
const TrainerBatchesBatchIdGradingRoute =
  TrainerBatchesBatchIdGradingRouteImport.update({
    id: '/grading',
    path: '/grading',
    getParentRoute: () => TrainerBatchesBatchIdRoute,
  } as any)
const TrainerBatchesBatchIdCurriculumRoute =
  TrainerBatchesBatchIdCurriculumRouteImport.update({
    id: '/curriculum',
    path: '/curriculum',
    getParentRoute: () => TrainerBatchesBatchIdRoute,
  } as any)
const TrainerBatchesBatchIdAttentionRoute =
  TrainerBatchesBatchIdAttentionRouteImport.update({
    id: '/attention',
    path: '/attention',
    getParentRoute: () => TrainerBatchesBatchIdRoute,
  } as any)
const TrainerBatchesBatchIdAnnouncementsRoute =
  TrainerBatchesBatchIdAnnouncementsRouteImport.update({
    id: '/announcements',
    path: '/announcements',
    getParentRoute: () => TrainerBatchesBatchIdRoute,
  } as any)
const AdminBatchesBatchIdEnrollmentRoute =
  AdminBatchesBatchIdEnrollmentRouteImport.update({
    id: '/enrollment',
    path: '/enrollment',
    getParentRoute: () => AdminBatchesBatchIdRoute,
  } as any)
const AdminBatchesBatchIdCurriculumRoute =
  AdminBatchesBatchIdCurriculumRouteImport.update({
    id: '/curriculum',
    path: '/curriculum',
    getParentRoute: () => AdminBatchesBatchIdRoute,
  } as any)
const StudentCoursesBatchIdLearnRoute =
  StudentCoursesBatchIdLearnRouteImport.update({
    id: '/courses/$batchId/learn',
    path: '/courses/$batchId/learn',
    getParentRoute: () => StudentRoute,
  } as any)
const TrainerBatchesBatchIdHackathonsIndexRoute =
  TrainerBatchesBatchIdHackathonsIndexRouteImport.update({
    id: '/hackathons/',
    path: '/hackathons/',
    getParentRoute: () => TrainerBatchesBatchIdRoute,
  } as any)
const AdminBatchesBatchIdHackathonsIndexRoute =
  AdminBatchesBatchIdHackathonsIndexRouteImport.update({
    id: '/hackathons/',
    path: '/hackathons/',
    getParentRoute: () => AdminBatchesBatchIdRoute,
  } as any)
const StudentCoursesBatchIdPracticeIndexRoute =
  StudentCoursesBatchIdPracticeIndexRouteImport.update({
    id: '/courses/$batchId/practice/',
    path: '/courses/$batchId/practice/',
    getParentRoute: () => StudentRoute,
  } as any)
const TrainerBatchesBatchIdWorkItemsAssessmentIdRoute =
  TrainerBatchesBatchIdWorkItemsAssessmentIdRouteImport.update({
    id: '/work-items/$assessmentId',
    path: '/work-items/$assessmentId',
    getParentRoute: () => TrainerBatchesBatchIdRoute,
  } as any)
const TrainerBatchesBatchIdHackathonsHackathonIdRoute =
  TrainerBatchesBatchIdHackathonsHackathonIdRouteImport.update({
    id: '/hackathons/$hackathonId',
    path: '/hackathons/$hackathonId',
    getParentRoute: () => TrainerBatchesBatchIdRoute,
  } as any)
const OrgBatchesBatchIdWorkItemsAssessmentIdRoute =
  OrgBatchesBatchIdWorkItemsAssessmentIdRouteImport.update({
    id: '/batches/$batchId/work-items/$assessmentId',
    path: '/batches/$batchId/work-items/$assessmentId',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgBatchesBatchIdStudentsUserIdRoute =
  OrgBatchesBatchIdStudentsUserIdRouteImport.update({
    id: '/batches/$batchId/students/$userId',
    path: '/batches/$batchId/students/$userId',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgBatchesBatchIdSessionsSessionIdRoute =
  OrgBatchesBatchIdSessionsSessionIdRouteImport.update({
    id: '/batches/$batchId/sessions/$sessionId',
    path: '/batches/$batchId/sessions/$sessionId',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgBatchesBatchIdAssignmentsAssignmentIdRoute =
  OrgBatchesBatchIdAssignmentsAssignmentIdRouteImport.update({
    id: '/batches/$batchId/assignments/$assignmentId',
    path: '/batches/$batchId/assignments/$assignmentId',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgBatchesBatchIdAssessmentsAssessmentIdRoute =
  OrgBatchesBatchIdAssessmentsAssessmentIdRouteImport.update({
    id: '/batches/$batchId/assessments/$assessmentId',
    path: '/batches/$batchId/assessments/$assessmentId',
    getParentRoute: () => OrgRoute,
  } as any)
const AdminBatchesBatchIdHackathonsHackathonIdRoute =
  AdminBatchesBatchIdHackathonsHackathonIdRouteImport.update({
    id: '/hackathons/$hackathonId',
    path: '/hackathons/$hackathonId',
    getParentRoute: () => AdminBatchesBatchIdRoute,
  } as any)
const StudentCoursesBatchIdTopicsTopicIdRoute =
  StudentCoursesBatchIdTopicsTopicIdRouteImport.update({
    id: '/courses/$batchId/topics/$topicId',
    path: '/courses/$batchId/topics/$topicId',
    getParentRoute: () => StudentRoute,
  } as any)
const StudentCoursesBatchIdTopicsTopicIdIndexRoute =
  StudentCoursesBatchIdTopicsTopicIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StudentCoursesBatchIdTopicsTopicIdRoute,
  } as any)
const StudentCoursesBatchIdPracticeCategoryIndexRoute =
  StudentCoursesBatchIdPracticeCategoryIndexRouteImport.update({
    id: '/courses/$batchId/practice/$category/',
    path: '/courses/$batchId/practice/$category/',
    getParentRoute: () => StudentRoute,
  } as any)
const StudentCoursesBatchIdTopicsTopicIdResourcesRoute =
  StudentCoursesBatchIdTopicsTopicIdResourcesRouteImport.update({
    id: '/resources',
    path: '/resources',
    getParentRoute: () => StudentCoursesBatchIdTopicsTopicIdRoute,
  } as any)
const StudentCoursesBatchIdTopicsTopicIdRecordingRoute =
  StudentCoursesBatchIdTopicsTopicIdRecordingRouteImport.update({
    id: '/recording',
    path: '/recording',
    getParentRoute: () => StudentCoursesBatchIdTopicsTopicIdRoute,
  } as any)
const StudentCoursesBatchIdTopicsTopicIdPracticeRoute =
  StudentCoursesBatchIdTopicsTopicIdPracticeRouteImport.update({
    id: '/practice',
    path: '/practice',
    getParentRoute: () => StudentCoursesBatchIdTopicsTopicIdRoute,
  } as any)
const StudentCoursesBatchIdTopicsTopicIdNotesRoute =
  StudentCoursesBatchIdTopicsTopicIdNotesRouteImport.update({
    id: '/notes',
    path: '/notes',
    getParentRoute: () => StudentCoursesBatchIdTopicsTopicIdRoute,
  } as any)
const StudentCoursesBatchIdTopicsTopicIdFeedbackRoute =
  StudentCoursesBatchIdTopicsTopicIdFeedbackRouteImport.update({
    id: '/feedback',
    path: '/feedback',
    getParentRoute: () => StudentCoursesBatchIdTopicsTopicIdRoute,
  } as any)
const StudentCoursesBatchIdTopicsTopicIdAskTrainerRoute =
  StudentCoursesBatchIdTopicsTopicIdAskTrainerRouteImport.update({
    id: '/ask-trainer',
    path: '/ask-trainer',
    getParentRoute: () => StudentCoursesBatchIdTopicsTopicIdRoute,
  } as any)
const StudentCoursesBatchIdPracticeCategoryAssessmentIdRoute =
  StudentCoursesBatchIdPracticeCategoryAssessmentIdRouteImport.update({
    id: '/courses/$batchId/practice/$category/$assessmentId',
    path: '/courses/$batchId/practice/$category/$assessmentId',
    getParentRoute: () => StudentRoute,
  } as any)
const StudentCoursesBatchIdTopicsTopicIdQuizAssessmentIdRoute =
  StudentCoursesBatchIdTopicsTopicIdQuizAssessmentIdRouteImport.update({
    id: '/courses/$batchId/topics/$topicId_/quiz/$assessmentId',
    path: '/courses/$batchId/topics/$topicId/quiz/$assessmentId',
    getParentRoute: () => StudentRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/org': typeof OrgRouteWithChildren
  '/trainer': typeof TrainerRouteWithChildren
  '/help': typeof StudentHelpRoute
  '/settings': typeof StudentSettingsRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/student-feedback': typeof AdminStudentFeedbackRoute
  '/admin/trainer-feedback': typeof AdminTrainerFeedbackRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/oauth-callback': typeof AuthOauthCallbackRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/setup': typeof AuthSetupRoute
  '/org/company-readiness': typeof OrgCompanyReadinessRoute
  '/org/messages': typeof OrgMessagesRoute
  '/org/readiness': typeof OrgReadinessRoute
  '/org/settings': typeof OrgSettingsRoute
  '/org/students': typeof OrgStudentsRoute
  '/org/support': typeof OrgSupportRoute
  '/trainer/analytics': typeof TrainerAnalyticsRoute
  '/trainer/dashboard': typeof TrainerDashboardRoute
  '/trainer/questions': typeof TrainerQuestionsRoute
  '/trainer/settings': typeof TrainerSettingsRoute
  '/admin/': typeof AdminIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/messages/': typeof MessagesIndexRoute
  '/org/': typeof OrgIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/trainer/': typeof TrainerIndexRoute
  '/hackathons/$hackathonId': typeof StudentHackathonsHackathonIdRoute
  '/problems/$slug': typeof StudentProblemsSlugRoute
  '/admin/batches/$batchId': typeof AdminBatchesBatchIdRouteWithChildren
  '/admin/curriculum/$templateId': typeof AdminCurriculumTemplateIdRoute
  '/admin/orgs/$orgId': typeof AdminOrgsOrgIdRoute
  '/admin/orgs/new': typeof AdminOrgsNewRoute
  '/admin/problems/$problemId': typeof AdminProblemsProblemIdRoute
  '/admin/problems/new': typeof AdminProblemsNewRoute
  '/trainer/batches/$batchId': typeof TrainerBatchesBatchIdRouteWithChildren
  '/trainer/problems/$problemId': typeof TrainerProblemsProblemIdRoute
  '/trainer/problems/new': typeof TrainerProblemsNewRoute
  '/contests/': typeof StudentContestsIndexRoute
  '/courses/': typeof StudentCoursesIndexRoute
  '/hackathons/': typeof StudentHackathonsIndexRoute
  '/leaderboard/': typeof StudentLeaderboardIndexRoute
  '/problems/': typeof StudentProblemsIndexRoute
  '/progress/': typeof StudentProgressIndexRoute
  '/schedule/': typeof StudentScheduleIndexRoute
  '/admin/batches/': typeof AdminBatchesIndexRoute
  '/admin/curriculum/': typeof AdminCurriculumIndexRoute
  '/admin/orgs/': typeof AdminOrgsIndexRoute
  '/admin/problems/': typeof AdminProblemsIndexRoute
  '/org/batches/': typeof OrgBatchesIndexRoute
  '/trainer/batches/': typeof TrainerBatchesIndexRoute
  '/trainer/problems/': typeof TrainerProblemsIndexRoute
  '/courses/$batchId/learn': typeof StudentCoursesBatchIdLearnRoute
  '/admin/batches/$batchId/curriculum': typeof AdminBatchesBatchIdCurriculumRoute
  '/admin/batches/$batchId/enrollment': typeof AdminBatchesBatchIdEnrollmentRoute
  '/trainer/batches/$batchId/announcements': typeof TrainerBatchesBatchIdAnnouncementsRoute
  '/trainer/batches/$batchId/attention': typeof TrainerBatchesBatchIdAttentionRoute
  '/trainer/batches/$batchId/curriculum': typeof TrainerBatchesBatchIdCurriculumRoute
  '/trainer/batches/$batchId/grading': typeof TrainerBatchesBatchIdGradingRoute
  '/trainer/batches/$batchId/overview': typeof TrainerBatchesBatchIdOverviewRoute
  '/trainer/batches/$batchId/sessions': typeof TrainerBatchesBatchIdSessionsRoute
  '/trainer/batches/$batchId/students': typeof TrainerBatchesBatchIdStudentsRoute
  '/courses/$batchId/': typeof StudentCoursesBatchIdIndexRoute
  '/admin/batches/$batchId/': typeof AdminBatchesBatchIdIndexRoute
  '/org/batches/$batchId/': typeof OrgBatchesBatchIdIndexRoute
  '/trainer/batches/$batchId/': typeof TrainerBatchesBatchIdIndexRoute
  '/courses/$batchId/topics/$topicId': typeof StudentCoursesBatchIdTopicsTopicIdRouteWithChildren
  '/admin/batches/$batchId/hackathons/$hackathonId': typeof AdminBatchesBatchIdHackathonsHackathonIdRoute
  '/org/batches/$batchId/assessments/$assessmentId': typeof OrgBatchesBatchIdAssessmentsAssessmentIdRoute
  '/org/batches/$batchId/assignments/$assignmentId': typeof OrgBatchesBatchIdAssignmentsAssignmentIdRoute
  '/org/batches/$batchId/sessions/$sessionId': typeof OrgBatchesBatchIdSessionsSessionIdRoute
  '/org/batches/$batchId/students/$userId': typeof OrgBatchesBatchIdStudentsUserIdRoute
  '/org/batches/$batchId/work-items/$assessmentId': typeof OrgBatchesBatchIdWorkItemsAssessmentIdRoute
  '/trainer/batches/$batchId/hackathons/$hackathonId': typeof TrainerBatchesBatchIdHackathonsHackathonIdRoute
  '/trainer/batches/$batchId/work-items/$assessmentId': typeof TrainerBatchesBatchIdWorkItemsAssessmentIdRoute
  '/courses/$batchId/practice/': typeof StudentCoursesBatchIdPracticeIndexRoute
  '/admin/batches/$batchId/hackathons/': typeof AdminBatchesBatchIdHackathonsIndexRoute
  '/trainer/batches/$batchId/hackathons/': typeof TrainerBatchesBatchIdHackathonsIndexRoute
  '/courses/$batchId/practice/$category/$assessmentId': typeof StudentCoursesBatchIdPracticeCategoryAssessmentIdRoute
  '/courses/$batchId/topics/$topicId/ask-trainer': typeof StudentCoursesBatchIdTopicsTopicIdAskTrainerRoute
  '/courses/$batchId/topics/$topicId/feedback': typeof StudentCoursesBatchIdTopicsTopicIdFeedbackRoute
  '/courses/$batchId/topics/$topicId/notes': typeof StudentCoursesBatchIdTopicsTopicIdNotesRoute
  '/courses/$batchId/topics/$topicId/practice': typeof StudentCoursesBatchIdTopicsTopicIdPracticeRoute
  '/courses/$batchId/topics/$topicId/recording': typeof StudentCoursesBatchIdTopicsTopicIdRecordingRoute
  '/courses/$batchId/topics/$topicId/resources': typeof StudentCoursesBatchIdTopicsTopicIdResourcesRoute
  '/courses/$batchId/practice/$category/': typeof StudentCoursesBatchIdPracticeCategoryIndexRoute
  '/courses/$batchId/topics/$topicId/': typeof StudentCoursesBatchIdTopicsTopicIdIndexRoute
  '/courses/$batchId/topics/$topicId/quiz/$assessmentId': typeof StudentCoursesBatchIdTopicsTopicIdQuizAssessmentIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/help': typeof StudentHelpRoute
  '/settings': typeof StudentSettingsRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/student-feedback': typeof AdminStudentFeedbackRoute
  '/admin/trainer-feedback': typeof AdminTrainerFeedbackRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/oauth-callback': typeof AuthOauthCallbackRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/setup': typeof AuthSetupRoute
  '/org/company-readiness': typeof OrgCompanyReadinessRoute
  '/org/messages': typeof OrgMessagesRoute
  '/org/readiness': typeof OrgReadinessRoute
  '/org/settings': typeof OrgSettingsRoute
  '/org/students': typeof OrgStudentsRoute
  '/org/support': typeof OrgSupportRoute
  '/trainer/analytics': typeof TrainerAnalyticsRoute
  '/trainer/dashboard': typeof TrainerDashboardRoute
  '/trainer/questions': typeof TrainerQuestionsRoute
  '/trainer/settings': typeof TrainerSettingsRoute
  '/admin': typeof AdminIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/messages': typeof MessagesIndexRoute
  '/org': typeof OrgIndexRoute
  '/profile': typeof ProfileIndexRoute
  '/trainer': typeof TrainerIndexRoute
  '/hackathons/$hackathonId': typeof StudentHackathonsHackathonIdRoute
  '/problems/$slug': typeof StudentProblemsSlugRoute
  '/admin/curriculum/$templateId': typeof AdminCurriculumTemplateIdRoute
  '/admin/orgs/$orgId': typeof AdminOrgsOrgIdRoute
  '/admin/orgs/new': typeof AdminOrgsNewRoute
  '/admin/problems/$problemId': typeof AdminProblemsProblemIdRoute
  '/admin/problems/new': typeof AdminProblemsNewRoute
  '/trainer/problems/$problemId': typeof TrainerProblemsProblemIdRoute
  '/trainer/problems/new': typeof TrainerProblemsNewRoute
  '/contests': typeof StudentContestsIndexRoute
  '/courses': typeof StudentCoursesIndexRoute
  '/hackathons': typeof StudentHackathonsIndexRoute
  '/leaderboard': typeof StudentLeaderboardIndexRoute
  '/problems': typeof StudentProblemsIndexRoute
  '/progress': typeof StudentProgressIndexRoute
  '/schedule': typeof StudentScheduleIndexRoute
  '/admin/batches': typeof AdminBatchesIndexRoute
  '/admin/curriculum': typeof AdminCurriculumIndexRoute
  '/admin/orgs': typeof AdminOrgsIndexRoute
  '/admin/problems': typeof AdminProblemsIndexRoute
  '/org/batches': typeof OrgBatchesIndexRoute
  '/trainer/batches': typeof TrainerBatchesIndexRoute
  '/trainer/problems': typeof TrainerProblemsIndexRoute
  '/courses/$batchId/learn': typeof StudentCoursesBatchIdLearnRoute
  '/admin/batches/$batchId/curriculum': typeof AdminBatchesBatchIdCurriculumRoute
  '/admin/batches/$batchId/enrollment': typeof AdminBatchesBatchIdEnrollmentRoute
  '/trainer/batches/$batchId/announcements': typeof TrainerBatchesBatchIdAnnouncementsRoute
  '/trainer/batches/$batchId/attention': typeof TrainerBatchesBatchIdAttentionRoute
  '/trainer/batches/$batchId/curriculum': typeof TrainerBatchesBatchIdCurriculumRoute
  '/trainer/batches/$batchId/grading': typeof TrainerBatchesBatchIdGradingRoute
  '/trainer/batches/$batchId/overview': typeof TrainerBatchesBatchIdOverviewRoute
  '/trainer/batches/$batchId/sessions': typeof TrainerBatchesBatchIdSessionsRoute
  '/trainer/batches/$batchId/students': typeof TrainerBatchesBatchIdStudentsRoute
  '/courses/$batchId': typeof StudentCoursesBatchIdIndexRoute
  '/admin/batches/$batchId': typeof AdminBatchesBatchIdIndexRoute
  '/org/batches/$batchId': typeof OrgBatchesBatchIdIndexRoute
  '/trainer/batches/$batchId': typeof TrainerBatchesBatchIdIndexRoute
  '/admin/batches/$batchId/hackathons/$hackathonId': typeof AdminBatchesBatchIdHackathonsHackathonIdRoute
  '/org/batches/$batchId/assessments/$assessmentId': typeof OrgBatchesBatchIdAssessmentsAssessmentIdRoute
  '/org/batches/$batchId/assignments/$assignmentId': typeof OrgBatchesBatchIdAssignmentsAssignmentIdRoute
  '/org/batches/$batchId/sessions/$sessionId': typeof OrgBatchesBatchIdSessionsSessionIdRoute
  '/org/batches/$batchId/students/$userId': typeof OrgBatchesBatchIdStudentsUserIdRoute
  '/org/batches/$batchId/work-items/$assessmentId': typeof OrgBatchesBatchIdWorkItemsAssessmentIdRoute
  '/trainer/batches/$batchId/hackathons/$hackathonId': typeof TrainerBatchesBatchIdHackathonsHackathonIdRoute
  '/trainer/batches/$batchId/work-items/$assessmentId': typeof TrainerBatchesBatchIdWorkItemsAssessmentIdRoute
  '/courses/$batchId/practice': typeof StudentCoursesBatchIdPracticeIndexRoute
  '/admin/batches/$batchId/hackathons': typeof AdminBatchesBatchIdHackathonsIndexRoute
  '/trainer/batches/$batchId/hackathons': typeof TrainerBatchesBatchIdHackathonsIndexRoute
  '/courses/$batchId/practice/$category/$assessmentId': typeof StudentCoursesBatchIdPracticeCategoryAssessmentIdRoute
  '/courses/$batchId/topics/$topicId/ask-trainer': typeof StudentCoursesBatchIdTopicsTopicIdAskTrainerRoute
  '/courses/$batchId/topics/$topicId/feedback': typeof StudentCoursesBatchIdTopicsTopicIdFeedbackRoute
  '/courses/$batchId/topics/$topicId/notes': typeof StudentCoursesBatchIdTopicsTopicIdNotesRoute
  '/courses/$batchId/topics/$topicId/practice': typeof StudentCoursesBatchIdTopicsTopicIdPracticeRoute
  '/courses/$batchId/topics/$topicId/recording': typeof StudentCoursesBatchIdTopicsTopicIdRecordingRoute
  '/courses/$batchId/topics/$topicId/resources': typeof StudentCoursesBatchIdTopicsTopicIdResourcesRoute
  '/courses/$batchId/practice/$category': typeof StudentCoursesBatchIdPracticeCategoryIndexRoute
  '/courses/$batchId/topics/$topicId': typeof StudentCoursesBatchIdTopicsTopicIdIndexRoute
  '/courses/$batchId/topics/$topicId/quiz/$assessmentId': typeof StudentCoursesBatchIdTopicsTopicIdQuizAssessmentIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_student': typeof StudentRouteWithChildren
  '/admin': typeof AdminRouteWithChildren
  '/login': typeof LoginRoute
  '/org': typeof OrgRouteWithChildren
  '/trainer': typeof TrainerRouteWithChildren
  '/_student/help': typeof StudentHelpRoute
  '/_student/settings': typeof StudentSettingsRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/dashboard': typeof AdminDashboardRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/student-feedback': typeof AdminStudentFeedbackRoute
  '/admin/trainer-feedback': typeof AdminTrainerFeedbackRoute
  '/admin/users': typeof AdminUsersRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/oauth-callback': typeof AuthOauthCallbackRoute
  '/auth/reset-password': typeof AuthResetPasswordRoute
  '/auth/setup': typeof AuthSetupRoute
  '/org/company-readiness': typeof OrgCompanyReadinessRoute
  '/org/messages': typeof OrgMessagesRoute
  '/org/readiness': typeof OrgReadinessRoute
  '/org/settings': typeof OrgSettingsRoute
  '/org/students': typeof OrgStudentsRoute
  '/org/support': typeof OrgSupportRoute
  '/trainer/analytics': typeof TrainerAnalyticsRoute
  '/trainer/dashboard': typeof TrainerDashboardRoute
  '/trainer/questions': typeof TrainerQuestionsRoute
  '/trainer/settings': typeof TrainerSettingsRoute
  '/admin/': typeof AdminIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/messages/': typeof MessagesIndexRoute
  '/org/': typeof OrgIndexRoute
  '/profile/': typeof ProfileIndexRoute
  '/trainer/': typeof TrainerIndexRoute
  '/_student/hackathons/$hackathonId': typeof StudentHackathonsHackathonIdRoute
  '/_student/problems/$slug': typeof StudentProblemsSlugRoute
  '/admin/batches/$batchId': typeof AdminBatchesBatchIdRouteWithChildren
  '/admin/curriculum/$templateId': typeof AdminCurriculumTemplateIdRoute
  '/admin/orgs/$orgId': typeof AdminOrgsOrgIdRoute
  '/admin/orgs/new': typeof AdminOrgsNewRoute
  '/admin/problems/$problemId': typeof AdminProblemsProblemIdRoute
  '/admin/problems/new': typeof AdminProblemsNewRoute
  '/trainer/batches/$batchId': typeof TrainerBatchesBatchIdRouteWithChildren
  '/trainer/problems/$problemId': typeof TrainerProblemsProblemIdRoute
  '/trainer/problems/new': typeof TrainerProblemsNewRoute
  '/_student/contests/': typeof StudentContestsIndexRoute
  '/_student/courses/': typeof StudentCoursesIndexRoute
  '/_student/hackathons/': typeof StudentHackathonsIndexRoute
  '/_student/leaderboard/': typeof StudentLeaderboardIndexRoute
  '/_student/problems/': typeof StudentProblemsIndexRoute
  '/_student/progress/': typeof StudentProgressIndexRoute
  '/_student/schedule/': typeof StudentScheduleIndexRoute
  '/admin/batches/': typeof AdminBatchesIndexRoute
  '/admin/curriculum/': typeof AdminCurriculumIndexRoute
  '/admin/orgs/': typeof AdminOrgsIndexRoute
  '/admin/problems/': typeof AdminProblemsIndexRoute
  '/org/batches/': typeof OrgBatchesIndexRoute
  '/trainer/batches/': typeof TrainerBatchesIndexRoute
  '/trainer/problems/': typeof TrainerProblemsIndexRoute
  '/_student/courses/$batchId/learn': typeof StudentCoursesBatchIdLearnRoute
  '/admin/batches/$batchId/curriculum': typeof AdminBatchesBatchIdCurriculumRoute
  '/admin/batches/$batchId/enrollment': typeof AdminBatchesBatchIdEnrollmentRoute
  '/trainer/batches/$batchId/announcements': typeof TrainerBatchesBatchIdAnnouncementsRoute
  '/trainer/batches/$batchId/attention': typeof TrainerBatchesBatchIdAttentionRoute
  '/trainer/batches/$batchId/curriculum': typeof TrainerBatchesBatchIdCurriculumRoute
  '/trainer/batches/$batchId/grading': typeof TrainerBatchesBatchIdGradingRoute
  '/trainer/batches/$batchId/overview': typeof TrainerBatchesBatchIdOverviewRoute
  '/trainer/batches/$batchId/sessions': typeof TrainerBatchesBatchIdSessionsRoute
  '/trainer/batches/$batchId/students': typeof TrainerBatchesBatchIdStudentsRoute
  '/_student/courses/$batchId/': typeof StudentCoursesBatchIdIndexRoute
  '/admin/batches/$batchId/': typeof AdminBatchesBatchIdIndexRoute
  '/org/batches/$batchId/': typeof OrgBatchesBatchIdIndexRoute
  '/trainer/batches/$batchId/': typeof TrainerBatchesBatchIdIndexRoute
  '/_student/courses/$batchId/topics/$topicId': typeof StudentCoursesBatchIdTopicsTopicIdRouteWithChildren
  '/admin/batches/$batchId/hackathons/$hackathonId': typeof AdminBatchesBatchIdHackathonsHackathonIdRoute
  '/org/batches/$batchId/assessments/$assessmentId': typeof OrgBatchesBatchIdAssessmentsAssessmentIdRoute
  '/org/batches/$batchId/assignments/$assignmentId': typeof OrgBatchesBatchIdAssignmentsAssignmentIdRoute
  '/org/batches/$batchId/sessions/$sessionId': typeof OrgBatchesBatchIdSessionsSessionIdRoute
  '/org/batches/$batchId/students/$userId': typeof OrgBatchesBatchIdStudentsUserIdRoute
  '/org/batches/$batchId/work-items/$assessmentId': typeof OrgBatchesBatchIdWorkItemsAssessmentIdRoute
  '/trainer/batches/$batchId/hackathons/$hackathonId': typeof TrainerBatchesBatchIdHackathonsHackathonIdRoute
  '/trainer/batches/$batchId/work-items/$assessmentId': typeof TrainerBatchesBatchIdWorkItemsAssessmentIdRoute
  '/_student/courses/$batchId/practice/': typeof StudentCoursesBatchIdPracticeIndexRoute
  '/admin/batches/$batchId/hackathons/': typeof AdminBatchesBatchIdHackathonsIndexRoute
  '/trainer/batches/$batchId/hackathons/': typeof TrainerBatchesBatchIdHackathonsIndexRoute
  '/_student/courses/$batchId/practice/$category/$assessmentId': typeof StudentCoursesBatchIdPracticeCategoryAssessmentIdRoute
  '/_student/courses/$batchId/topics/$topicId/ask-trainer': typeof StudentCoursesBatchIdTopicsTopicIdAskTrainerRoute
  '/_student/courses/$batchId/topics/$topicId/feedback': typeof StudentCoursesBatchIdTopicsTopicIdFeedbackRoute
  '/_student/courses/$batchId/topics/$topicId/notes': typeof StudentCoursesBatchIdTopicsTopicIdNotesRoute
  '/_student/courses/$batchId/topics/$topicId/practice': typeof StudentCoursesBatchIdTopicsTopicIdPracticeRoute
  '/_student/courses/$batchId/topics/$topicId/recording': typeof StudentCoursesBatchIdTopicsTopicIdRecordingRoute
  '/_student/courses/$batchId/topics/$topicId/resources': typeof StudentCoursesBatchIdTopicsTopicIdResourcesRoute
  '/_student/courses/$batchId/practice/$category/': typeof StudentCoursesBatchIdPracticeCategoryIndexRoute
  '/_student/courses/$batchId/topics/$topicId/': typeof StudentCoursesBatchIdTopicsTopicIdIndexRoute
  '/_student/courses/$batchId/topics/$topicId_/quiz/$assessmentId': typeof StudentCoursesBatchIdTopicsTopicIdQuizAssessmentIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/login'
    | '/org'
    | '/trainer'
    | '/help'
    | '/settings'
    | '/admin/analytics'
    | '/admin/dashboard'
    | '/admin/settings'
    | '/admin/student-feedback'
    | '/admin/trainer-feedback'
    | '/admin/users'
    | '/auth/forgot-password'
    | '/auth/oauth-callback'
    | '/auth/reset-password'
    | '/auth/setup'
    | '/org/company-readiness'
    | '/org/messages'
    | '/org/readiness'
    | '/org/settings'
    | '/org/students'
    | '/org/support'
    | '/trainer/analytics'
    | '/trainer/dashboard'
    | '/trainer/questions'
    | '/trainer/settings'
    | '/admin/'
    | '/dashboard/'
    | '/messages/'
    | '/org/'
    | '/profile/'
    | '/trainer/'
    | '/hackathons/$hackathonId'
    | '/problems/$slug'
    | '/admin/batches/$batchId'
    | '/admin/curriculum/$templateId'
    | '/admin/orgs/$orgId'
    | '/admin/orgs/new'
    | '/admin/problems/$problemId'
    | '/admin/problems/new'
    | '/trainer/batches/$batchId'
    | '/trainer/problems/$problemId'
    | '/trainer/problems/new'
    | '/contests/'
    | '/courses/'
    | '/hackathons/'
    | '/leaderboard/'
    | '/problems/'
    | '/progress/'
    | '/schedule/'
    | '/admin/batches/'
    | '/admin/curriculum/'
    | '/admin/orgs/'
    | '/admin/problems/'
    | '/org/batches/'
    | '/trainer/batches/'
    | '/trainer/problems/'
    | '/courses/$batchId/learn'
    | '/admin/batches/$batchId/curriculum'
    | '/admin/batches/$batchId/enrollment'
    | '/trainer/batches/$batchId/announcements'
    | '/trainer/batches/$batchId/attention'
    | '/trainer/batches/$batchId/curriculum'
    | '/trainer/batches/$batchId/grading'
    | '/trainer/batches/$batchId/overview'
    | '/trainer/batches/$batchId/sessions'
    | '/trainer/batches/$batchId/students'
    | '/courses/$batchId/'
    | '/admin/batches/$batchId/'
    | '/org/batches/$batchId/'
    | '/trainer/batches/$batchId/'
    | '/courses/$batchId/topics/$topicId'
    | '/admin/batches/$batchId/hackathons/$hackathonId'
    | '/org/batches/$batchId/assessments/$assessmentId'
    | '/org/batches/$batchId/assignments/$assignmentId'
    | '/org/batches/$batchId/sessions/$sessionId'
    | '/org/batches/$batchId/students/$userId'
    | '/org/batches/$batchId/work-items/$assessmentId'
    | '/trainer/batches/$batchId/hackathons/$hackathonId'
    | '/trainer/batches/$batchId/work-items/$assessmentId'
    | '/courses/$batchId/practice/'
    | '/admin/batches/$batchId/hackathons/'
    | '/trainer/batches/$batchId/hackathons/'
    | '/courses/$batchId/practice/$category/$assessmentId'
    | '/courses/$batchId/topics/$topicId/ask-trainer'
    | '/courses/$batchId/topics/$topicId/feedback'
    | '/courses/$batchId/topics/$topicId/notes'
    | '/courses/$batchId/topics/$topicId/practice'
    | '/courses/$batchId/topics/$topicId/recording'
    | '/courses/$batchId/topics/$topicId/resources'
    | '/courses/$batchId/practice/$category/'
    | '/courses/$batchId/topics/$topicId/'
    | '/courses/$batchId/topics/$topicId/quiz/$assessmentId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/help'
    | '/settings'
    | '/admin/analytics'
    | '/admin/dashboard'
    | '/admin/settings'
    | '/admin/student-feedback'
    | '/admin/trainer-feedback'
    | '/admin/users'
    | '/auth/forgot-password'
    | '/auth/oauth-callback'
    | '/auth/reset-password'
    | '/auth/setup'
    | '/org/company-readiness'
    | '/org/messages'
    | '/org/readiness'
    | '/org/settings'
    | '/org/students'
    | '/org/support'
    | '/trainer/analytics'
    | '/trainer/dashboard'
    | '/trainer/questions'
    | '/trainer/settings'
    | '/admin'
    | '/dashboard'
    | '/messages'
    | '/org'
    | '/profile'
    | '/trainer'
    | '/hackathons/$hackathonId'
    | '/problems/$slug'
    | '/admin/curriculum/$templateId'
    | '/admin/orgs/$orgId'
    | '/admin/orgs/new'
    | '/admin/problems/$problemId'
    | '/admin/problems/new'
    | '/trainer/problems/$problemId'
    | '/trainer/problems/new'
    | '/contests'
    | '/courses'
    | '/hackathons'
    | '/leaderboard'
    | '/problems'
    | '/progress'
    | '/schedule'
    | '/admin/batches'
    | '/admin/curriculum'
    | '/admin/orgs'
    | '/admin/problems'
    | '/org/batches'
    | '/trainer/batches'
    | '/trainer/problems'
    | '/courses/$batchId/learn'
    | '/admin/batches/$batchId/curriculum'
    | '/admin/batches/$batchId/enrollment'
    | '/trainer/batches/$batchId/announcements'
    | '/trainer/batches/$batchId/attention'
    | '/trainer/batches/$batchId/curriculum'
    | '/trainer/batches/$batchId/grading'
    | '/trainer/batches/$batchId/overview'
    | '/trainer/batches/$batchId/sessions'
    | '/trainer/batches/$batchId/students'
    | '/courses/$batchId'
    | '/admin/batches/$batchId'
    | '/org/batches/$batchId'
    | '/trainer/batches/$batchId'
    | '/admin/batches/$batchId/hackathons/$hackathonId'
    | '/org/batches/$batchId/assessments/$assessmentId'
    | '/org/batches/$batchId/assignments/$assignmentId'
    | '/org/batches/$batchId/sessions/$sessionId'
    | '/org/batches/$batchId/students/$userId'
    | '/org/batches/$batchId/work-items/$assessmentId'
    | '/trainer/batches/$batchId/hackathons/$hackathonId'
    | '/trainer/batches/$batchId/work-items/$assessmentId'
    | '/courses/$batchId/practice'
    | '/admin/batches/$batchId/hackathons'
    | '/trainer/batches/$batchId/hackathons'
    | '/courses/$batchId/practice/$category/$assessmentId'
    | '/courses/$batchId/topics/$topicId/ask-trainer'
    | '/courses/$batchId/topics/$topicId/feedback'
    | '/courses/$batchId/topics/$topicId/notes'
    | '/courses/$batchId/topics/$topicId/practice'
    | '/courses/$batchId/topics/$topicId/recording'
    | '/courses/$batchId/topics/$topicId/resources'
    | '/courses/$batchId/practice/$category'
    | '/courses/$batchId/topics/$topicId'
    | '/courses/$batchId/topics/$topicId/quiz/$assessmentId'
  id:
    | '__root__'
    | '/'
    | '/_student'
    | '/admin'
    | '/login'
    | '/org'
    | '/trainer'
    | '/_student/help'
    | '/_student/settings'
    | '/admin/analytics'
    | '/admin/dashboard'
    | '/admin/settings'
    | '/admin/student-feedback'
    | '/admin/trainer-feedback'
    | '/admin/users'
    | '/auth/forgot-password'
    | '/auth/oauth-callback'
    | '/auth/reset-password'
    | '/auth/setup'
    | '/org/company-readiness'
    | '/org/messages'
    | '/org/readiness'
    | '/org/settings'
    | '/org/students'
    | '/org/support'
    | '/trainer/analytics'
    | '/trainer/dashboard'
    | '/trainer/questions'
    | '/trainer/settings'
    | '/admin/'
    | '/dashboard/'
    | '/messages/'
    | '/org/'
    | '/profile/'
    | '/trainer/'
    | '/_student/hackathons/$hackathonId'
    | '/_student/problems/$slug'
    | '/admin/batches/$batchId'
    | '/admin/curriculum/$templateId'
    | '/admin/orgs/$orgId'
    | '/admin/orgs/new'
    | '/admin/problems/$problemId'
    | '/admin/problems/new'
    | '/trainer/batches/$batchId'
    | '/trainer/problems/$problemId'
    | '/trainer/problems/new'
    | '/_student/contests/'
    | '/_student/courses/'
    | '/_student/hackathons/'
    | '/_student/leaderboard/'
    | '/_student/problems/'
    | '/_student/progress/'
    | '/_student/schedule/'
    | '/admin/batches/'
    | '/admin/curriculum/'
    | '/admin/orgs/'
    | '/admin/problems/'
    | '/org/batches/'
    | '/trainer/batches/'
    | '/trainer/problems/'
    | '/_student/courses/$batchId/learn'
    | '/admin/batches/$batchId/curriculum'
    | '/admin/batches/$batchId/enrollment'
    | '/trainer/batches/$batchId/announcements'
    | '/trainer/batches/$batchId/attention'
    | '/trainer/batches/$batchId/curriculum'
    | '/trainer/batches/$batchId/grading'
    | '/trainer/batches/$batchId/overview'
    | '/trainer/batches/$batchId/sessions'
    | '/trainer/batches/$batchId/students'
    | '/_student/courses/$batchId/'
    | '/admin/batches/$batchId/'
    | '/org/batches/$batchId/'
    | '/trainer/batches/$batchId/'
    | '/_student/courses/$batchId/topics/$topicId'
    | '/admin/batches/$batchId/hackathons/$hackathonId'
    | '/org/batches/$batchId/assessments/$assessmentId'
    | '/org/batches/$batchId/assignments/$assignmentId'
    | '/org/batches/$batchId/sessions/$sessionId'
    | '/org/batches/$batchId/students/$userId'
    | '/org/batches/$batchId/work-items/$assessmentId'
    | '/trainer/batches/$batchId/hackathons/$hackathonId'
    | '/trainer/batches/$batchId/work-items/$assessmentId'
    | '/_student/courses/$batchId/practice/'
    | '/admin/batches/$batchId/hackathons/'
    | '/trainer/batches/$batchId/hackathons/'
    | '/_student/courses/$batchId/practice/$category/$assessmentId'
    | '/_student/courses/$batchId/topics/$topicId/ask-trainer'
    | '/_student/courses/$batchId/topics/$topicId/feedback'
    | '/_student/courses/$batchId/topics/$topicId/notes'
    | '/_student/courses/$batchId/topics/$topicId/practice'
    | '/_student/courses/$batchId/topics/$topicId/recording'
    | '/_student/courses/$batchId/topics/$topicId/resources'
    | '/_student/courses/$batchId/practice/$category/'
    | '/_student/courses/$batchId/topics/$topicId/'
    | '/_student/courses/$batchId/topics/$topicId_/quiz/$assessmentId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  StudentRoute: typeof StudentRouteWithChildren
  AdminRoute: typeof AdminRouteWithChildren
  LoginRoute: typeof LoginRoute
  OrgRoute: typeof OrgRouteWithChildren
  TrainerRoute: typeof TrainerRouteWithChildren
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthOauthCallbackRoute: typeof AuthOauthCallbackRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSetupRoute: typeof AuthSetupRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  MessagesIndexRoute: typeof MessagesIndexRoute
  ProfileIndexRoute: typeof ProfileIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/trainer': {
      id: '/trainer'
      path: '/trainer'
      fullPath: '/trainer'
      preLoaderRoute: typeof TrainerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org': {
      id: '/org'
      path: '/org'
      fullPath: '/org'
      preLoaderRoute: typeof OrgRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_student': {
      id: '/_student'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof StudentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/trainer/': {
      id: '/trainer/'
      path: '/'
      fullPath: '/trainer/'
      preLoaderRoute: typeof TrainerIndexRouteImport
      parentRoute: typeof TrainerRoute
    }
    '/profile/': {
      id: '/profile/'
      path: '/profile'
      fullPath: '/profile/'
      preLoaderRoute: typeof ProfileIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/org/': {
      id: '/org/'
      path: '/'
      fullPath: '/org/'
      preLoaderRoute: typeof OrgIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/messages/': {
      id: '/messages/'
      path: '/messages'
      fullPath: '/messages/'
      preLoaderRoute: typeof MessagesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/trainer/settings': {
      id: '/trainer/settings'
      path: '/settings'
      fullPath: '/trainer/settings'
      preLoaderRoute: typeof TrainerSettingsRouteImport
      parentRoute: typeof TrainerRoute
    }
    '/trainer/questions': {
      id: '/trainer/questions'
      path: '/questions'
      fullPath: '/trainer/questions'
      preLoaderRoute: typeof TrainerQuestionsRouteImport
      parentRoute: typeof TrainerRoute
    }
    '/trainer/dashboard': {
      id: '/trainer/dashboard'
      path: '/dashboard'
      fullPath: '/trainer/dashboard'
      preLoaderRoute: typeof TrainerDashboardRouteImport
      parentRoute: typeof TrainerRoute
    }
    '/trainer/analytics': {
      id: '/trainer/analytics'
      path: '/analytics'
      fullPath: '/trainer/analytics'
      preLoaderRoute: typeof TrainerAnalyticsRouteImport
      parentRoute: typeof TrainerRoute
    }
    '/org/support': {
      id: '/org/support'
      path: '/support'
      fullPath: '/org/support'
      preLoaderRoute: typeof OrgSupportRouteImport
      parentRoute: typeof OrgRoute
    }
    '/org/students': {
      id: '/org/students'
      path: '/students'
      fullPath: '/org/students'
      preLoaderRoute: typeof OrgStudentsRouteImport
      parentRoute: typeof OrgRoute
    }
    '/org/settings': {
      id: '/org/settings'
      path: '/settings'
      fullPath: '/org/settings'
      preLoaderRoute: typeof OrgSettingsRouteImport
      parentRoute: typeof OrgRoute
    }
    '/org/readiness': {
      id: '/org/readiness'
      path: '/readiness'
      fullPath: '/org/readiness'
      preLoaderRoute: typeof OrgReadinessRouteImport
      parentRoute: typeof OrgRoute
    }
    '/org/messages': {
      id: '/org/messages'
      path: '/messages'
      fullPath: '/org/messages'
      preLoaderRoute: typeof OrgMessagesRouteImport
      parentRoute: typeof OrgRoute
    }
    '/org/company-readiness': {
      id: '/org/company-readiness'
      path: '/company-readiness'
      fullPath: '/org/company-readiness'
      preLoaderRoute: typeof OrgCompanyReadinessRouteImport
      parentRoute: typeof OrgRoute
    }
    '/auth/setup': {
      id: '/auth/setup'
      path: '/auth/setup'
      fullPath: '/auth/setup'
      preLoaderRoute: typeof AuthSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/auth/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/oauth-callback': {
      id: '/auth/oauth-callback'
      path: '/auth/oauth-callback'
      fullPath: '/auth/oauth-callback'
      preLoaderRoute: typeof AuthOauthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/auth/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/trainer-feedback': {
      id: '/admin/trainer-feedback'
      path: '/trainer-feedback'
      fullPath: '/admin/trainer-feedback'
      preLoaderRoute: typeof AdminTrainerFeedbackRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/student-feedback': {
      id: '/admin/student-feedback'
      path: '/student-feedback'
      fullPath: '/admin/student-feedback'
      preLoaderRoute: typeof AdminStudentFeedbackRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/dashboard': {
      id: '/admin/dashboard'
      path: '/dashboard'
      fullPath: '/admin/dashboard'
      preLoaderRoute: typeof AdminDashboardRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/analytics': {
      id: '/admin/analytics'
      path: '/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AdminAnalyticsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_student/settings': {
      id: '/_student/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof StudentSettingsRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_student/help': {
      id: '/_student/help'
      path: '/help'
      fullPath: '/help'
      preLoaderRoute: typeof StudentHelpRouteImport
      parentRoute: typeof StudentRoute
    }
    '/trainer/problems/': {
      id: '/trainer/problems/'
      path: '/problems'
      fullPath: '/trainer/problems/'
      preLoaderRoute: typeof TrainerProblemsIndexRouteImport
      parentRoute: typeof TrainerRoute
    }
    '/trainer/batches/': {
      id: '/trainer/batches/'
      path: '/batches'
      fullPath: '/trainer/batches/'
      preLoaderRoute: typeof TrainerBatchesIndexRouteImport
      parentRoute: typeof TrainerRoute
    }
    '/org/batches/': {
      id: '/org/batches/'
      path: '/batches'
      fullPath: '/org/batches/'
      preLoaderRoute: typeof OrgBatchesIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/admin/problems/': {
      id: '/admin/problems/'
      path: '/problems'
      fullPath: '/admin/problems/'
      preLoaderRoute: typeof AdminProblemsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/orgs/': {
      id: '/admin/orgs/'
      path: '/orgs'
      fullPath: '/admin/orgs/'
      preLoaderRoute: typeof AdminOrgsIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/curriculum/': {
      id: '/admin/curriculum/'
      path: '/curriculum'
      fullPath: '/admin/curriculum/'
      preLoaderRoute: typeof AdminCurriculumIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/batches/': {
      id: '/admin/batches/'
      path: '/batches'
      fullPath: '/admin/batches/'
      preLoaderRoute: typeof AdminBatchesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_student/schedule/': {
      id: '/_student/schedule/'
      path: '/schedule'
      fullPath: '/schedule/'
      preLoaderRoute: typeof StudentScheduleIndexRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_student/progress/': {
      id: '/_student/progress/'
      path: '/progress'
      fullPath: '/progress/'
      preLoaderRoute: typeof StudentProgressIndexRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_student/problems/': {
      id: '/_student/problems/'
      path: '/problems'
      fullPath: '/problems/'
      preLoaderRoute: typeof StudentProblemsIndexRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_student/leaderboard/': {
      id: '/_student/leaderboard/'
      path: '/leaderboard'
      fullPath: '/leaderboard/'
      preLoaderRoute: typeof StudentLeaderboardIndexRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_student/hackathons/': {
      id: '/_student/hackathons/'
      path: '/hackathons'
      fullPath: '/hackathons/'
      preLoaderRoute: typeof StudentHackathonsIndexRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_student/courses/': {
      id: '/_student/courses/'
      path: '/courses'
      fullPath: '/courses/'
      preLoaderRoute: typeof StudentCoursesIndexRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_student/contests/': {
      id: '/_student/contests/'
      path: '/contests'
      fullPath: '/contests/'
      preLoaderRoute: typeof StudentContestsIndexRouteImport
      parentRoute: typeof StudentRoute
    }
    '/trainer/problems/new': {
      id: '/trainer/problems/new'
      path: '/problems/new'
      fullPath: '/trainer/problems/new'
      preLoaderRoute: typeof TrainerProblemsNewRouteImport
      parentRoute: typeof TrainerRoute
    }
    '/trainer/problems/$problemId': {
      id: '/trainer/problems/$problemId'
      path: '/problems/$problemId'
      fullPath: '/trainer/problems/$problemId'
      preLoaderRoute: typeof TrainerProblemsProblemIdRouteImport
      parentRoute: typeof TrainerRoute
    }
    '/trainer/batches/$batchId': {
      id: '/trainer/batches/$batchId'
      path: '/batches/$batchId'
      fullPath: '/trainer/batches/$batchId'
      preLoaderRoute: typeof TrainerBatchesBatchIdRouteImport
      parentRoute: typeof TrainerRoute
    }
    '/admin/problems/new': {
      id: '/admin/problems/new'
      path: '/problems/new'
      fullPath: '/admin/problems/new'
      preLoaderRoute: typeof AdminProblemsNewRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/problems/$problemId': {
      id: '/admin/problems/$problemId'
      path: '/problems/$problemId'
      fullPath: '/admin/problems/$problemId'
      preLoaderRoute: typeof AdminProblemsProblemIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/orgs/new': {
      id: '/admin/orgs/new'
      path: '/orgs/new'
      fullPath: '/admin/orgs/new'
      preLoaderRoute: typeof AdminOrgsNewRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/orgs/$orgId': {
      id: '/admin/orgs/$orgId'
      path: '/orgs/$orgId'
      fullPath: '/admin/orgs/$orgId'
      preLoaderRoute: typeof AdminOrgsOrgIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/curriculum/$templateId': {
      id: '/admin/curriculum/$templateId'
      path: '/curriculum/$templateId'
      fullPath: '/admin/curriculum/$templateId'
      preLoaderRoute: typeof AdminCurriculumTemplateIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/batches/$batchId': {
      id: '/admin/batches/$batchId'
      path: '/batches/$batchId'
      fullPath: '/admin/batches/$batchId'
      preLoaderRoute: typeof AdminBatchesBatchIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/_student/problems/$slug': {
      id: '/_student/problems/$slug'
      path: '/problems/$slug'
      fullPath: '/problems/$slug'
      preLoaderRoute: typeof StudentProblemsSlugRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_student/hackathons/$hackathonId': {
      id: '/_student/hackathons/$hackathonId'
      path: '/hackathons/$hackathonId'
      fullPath: '/hackathons/$hackathonId'
      preLoaderRoute: typeof StudentHackathonsHackathonIdRouteImport
      parentRoute: typeof StudentRoute
    }
    '/trainer/batches/$batchId/': {
      id: '/trainer/batches/$batchId/'
      path: '/'
      fullPath: '/trainer/batches/$batchId/'
      preLoaderRoute: typeof TrainerBatchesBatchIdIndexRouteImport
      parentRoute: typeof TrainerBatchesBatchIdRoute
    }
    '/org/batches/$batchId/': {
      id: '/org/batches/$batchId/'
      path: '/batches/$batchId'
      fullPath: '/org/batches/$batchId/'
      preLoaderRoute: typeof OrgBatchesBatchIdIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/admin/batches/$batchId/': {
      id: '/admin/batches/$batchId/'
      path: '/'
      fullPath: '/admin/batches/$batchId/'
      preLoaderRoute: typeof AdminBatchesBatchIdIndexRouteImport
      parentRoute: typeof AdminBatchesBatchIdRoute
    }
    '/_student/courses/$batchId/': {
      id: '/_student/courses/$batchId/'
      path: '/courses/$batchId'
      fullPath: '/courses/$batchId/'
      preLoaderRoute: typeof StudentCoursesBatchIdIndexRouteImport
      parentRoute: typeof StudentRoute
    }
    '/trainer/batches/$batchId/students': {
      id: '/trainer/batches/$batchId/students'
      path: '/students'
      fullPath: '/trainer/batches/$batchId/students'
      preLoaderRoute: typeof TrainerBatchesBatchIdStudentsRouteImport
      parentRoute: typeof TrainerBatchesBatchIdRoute
    }
    '/trainer/batches/$batchId/sessions': {
      id: '/trainer/batches/$batchId/sessions'
      path: '/sessions'
      fullPath: '/trainer/batches/$batchId/sessions'
      preLoaderRoute: typeof TrainerBatchesBatchIdSessionsRouteImport
      parentRoute: typeof TrainerBatchesBatchIdRoute
    }
    '/trainer/batches/$batchId/overview': {
      id: '/trainer/batches/$batchId/overview'
      path: '/overview'
      fullPath: '/trainer/batches/$batchId/overview'
      preLoaderRoute: typeof TrainerBatchesBatchIdOverviewRouteImport
      parentRoute: typeof TrainerBatchesBatchIdRoute
    }
    '/trainer/batches/$batchId/grading': {
      id: '/trainer/batches/$batchId/grading'
      path: '/grading'
      fullPath: '/trainer/batches/$batchId/grading'
      preLoaderRoute: typeof TrainerBatchesBatchIdGradingRouteImport
      parentRoute: typeof TrainerBatchesBatchIdRoute
    }
    '/trainer/batches/$batchId/curriculum': {
      id: '/trainer/batches/$batchId/curriculum'
      path: '/curriculum'
      fullPath: '/trainer/batches/$batchId/curriculum'
      preLoaderRoute: typeof TrainerBatchesBatchIdCurriculumRouteImport
      parentRoute: typeof TrainerBatchesBatchIdRoute
    }
    '/trainer/batches/$batchId/attention': {
      id: '/trainer/batches/$batchId/attention'
      path: '/attention'
      fullPath: '/trainer/batches/$batchId/attention'
      preLoaderRoute: typeof TrainerBatchesBatchIdAttentionRouteImport
      parentRoute: typeof TrainerBatchesBatchIdRoute
    }
    '/trainer/batches/$batchId/announcements': {
      id: '/trainer/batches/$batchId/announcements'
      path: '/announcements'
      fullPath: '/trainer/batches/$batchId/announcements'
      preLoaderRoute: typeof TrainerBatchesBatchIdAnnouncementsRouteImport
      parentRoute: typeof TrainerBatchesBatchIdRoute
    }
    '/admin/batches/$batchId/enrollment': {
      id: '/admin/batches/$batchId/enrollment'
      path: '/enrollment'
      fullPath: '/admin/batches/$batchId/enrollment'
      preLoaderRoute: typeof AdminBatchesBatchIdEnrollmentRouteImport
      parentRoute: typeof AdminBatchesBatchIdRoute
    }
    '/admin/batches/$batchId/curriculum': {
      id: '/admin/batches/$batchId/curriculum'
      path: '/curriculum'
      fullPath: '/admin/batches/$batchId/curriculum'
      preLoaderRoute: typeof AdminBatchesBatchIdCurriculumRouteImport
      parentRoute: typeof AdminBatchesBatchIdRoute
    }
    '/_student/courses/$batchId/learn': {
      id: '/_student/courses/$batchId/learn'
      path: '/courses/$batchId/learn'
      fullPath: '/courses/$batchId/learn'
      preLoaderRoute: typeof StudentCoursesBatchIdLearnRouteImport
      parentRoute: typeof StudentRoute
    }
    '/trainer/batches/$batchId/hackathons/': {
      id: '/trainer/batches/$batchId/hackathons/'
      path: '/hackathons'
      fullPath: '/trainer/batches/$batchId/hackathons/'
      preLoaderRoute: typeof TrainerBatchesBatchIdHackathonsIndexRouteImport
      parentRoute: typeof TrainerBatchesBatchIdRoute
    }
    '/admin/batches/$batchId/hackathons/': {
      id: '/admin/batches/$batchId/hackathons/'
      path: '/hackathons'
      fullPath: '/admin/batches/$batchId/hackathons/'
      preLoaderRoute: typeof AdminBatchesBatchIdHackathonsIndexRouteImport
      parentRoute: typeof AdminBatchesBatchIdRoute
    }
    '/_student/courses/$batchId/practice/': {
      id: '/_student/courses/$batchId/practice/'
      path: '/courses/$batchId/practice'
      fullPath: '/courses/$batchId/practice/'
      preLoaderRoute: typeof StudentCoursesBatchIdPracticeIndexRouteImport
      parentRoute: typeof StudentRoute
    }
    '/trainer/batches/$batchId/work-items/$assessmentId': {
      id: '/trainer/batches/$batchId/work-items/$assessmentId'
      path: '/work-items/$assessmentId'
      fullPath: '/trainer/batches/$batchId/work-items/$assessmentId'
      preLoaderRoute: typeof TrainerBatchesBatchIdWorkItemsAssessmentIdRouteImport
      parentRoute: typeof TrainerBatchesBatchIdRoute
    }
    '/trainer/batches/$batchId/hackathons/$hackathonId': {
      id: '/trainer/batches/$batchId/hackathons/$hackathonId'
      path: '/hackathons/$hackathonId'
      fullPath: '/trainer/batches/$batchId/hackathons/$hackathonId'
      preLoaderRoute: typeof TrainerBatchesBatchIdHackathonsHackathonIdRouteImport
      parentRoute: typeof TrainerBatchesBatchIdRoute
    }
    '/org/batches/$batchId/work-items/$assessmentId': {
      id: '/org/batches/$batchId/work-items/$assessmentId'
      path: '/batches/$batchId/work-items/$assessmentId'
      fullPath: '/org/batches/$batchId/work-items/$assessmentId'
      preLoaderRoute: typeof OrgBatchesBatchIdWorkItemsAssessmentIdRouteImport
      parentRoute: typeof OrgRoute
    }
    '/org/batches/$batchId/students/$userId': {
      id: '/org/batches/$batchId/students/$userId'
      path: '/batches/$batchId/students/$userId'
      fullPath: '/org/batches/$batchId/students/$userId'
      preLoaderRoute: typeof OrgBatchesBatchIdStudentsUserIdRouteImport
      parentRoute: typeof OrgRoute
    }
    '/org/batches/$batchId/sessions/$sessionId': {
      id: '/org/batches/$batchId/sessions/$sessionId'
      path: '/batches/$batchId/sessions/$sessionId'
      fullPath: '/org/batches/$batchId/sessions/$sessionId'
      preLoaderRoute: typeof OrgBatchesBatchIdSessionsSessionIdRouteImport
      parentRoute: typeof OrgRoute
    }
    '/org/batches/$batchId/assignments/$assignmentId': {
      id: '/org/batches/$batchId/assignments/$assignmentId'
      path: '/batches/$batchId/assignments/$assignmentId'
      fullPath: '/org/batches/$batchId/assignments/$assignmentId'
      preLoaderRoute: typeof OrgBatchesBatchIdAssignmentsAssignmentIdRouteImport
      parentRoute: typeof OrgRoute
    }
    '/org/batches/$batchId/assessments/$assessmentId': {
      id: '/org/batches/$batchId/assessments/$assessmentId'
      path: '/batches/$batchId/assessments/$assessmentId'
      fullPath: '/org/batches/$batchId/assessments/$assessmentId'
      preLoaderRoute: typeof OrgBatchesBatchIdAssessmentsAssessmentIdRouteImport
      parentRoute: typeof OrgRoute
    }
    '/admin/batches/$batchId/hackathons/$hackathonId': {
      id: '/admin/batches/$batchId/hackathons/$hackathonId'
      path: '/hackathons/$hackathonId'
      fullPath: '/admin/batches/$batchId/hackathons/$hackathonId'
      preLoaderRoute: typeof AdminBatchesBatchIdHackathonsHackathonIdRouteImport
      parentRoute: typeof AdminBatchesBatchIdRoute
    }
    '/_student/courses/$batchId/topics/$topicId': {
      id: '/_student/courses/$batchId/topics/$topicId'
      path: '/courses/$batchId/topics/$topicId'
      fullPath: '/courses/$batchId/topics/$topicId'
      preLoaderRoute: typeof StudentCoursesBatchIdTopicsTopicIdRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_student/courses/$batchId/topics/$topicId/': {
      id: '/_student/courses/$batchId/topics/$topicId/'
      path: '/'
      fullPath: '/courses/$batchId/topics/$topicId/'
      preLoaderRoute: typeof StudentCoursesBatchIdTopicsTopicIdIndexRouteImport
      parentRoute: typeof StudentCoursesBatchIdTopicsTopicIdRoute
    }
    '/_student/courses/$batchId/practice/$category/': {
      id: '/_student/courses/$batchId/practice/$category/'
      path: '/courses/$batchId/practice/$category'
      fullPath: '/courses/$batchId/practice/$category/'
      preLoaderRoute: typeof StudentCoursesBatchIdPracticeCategoryIndexRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_student/courses/$batchId/topics/$topicId/resources': {
      id: '/_student/courses/$batchId/topics/$topicId/resources'
      path: '/resources'
      fullPath: '/courses/$batchId/topics/$topicId/resources'
      preLoaderRoute: typeof StudentCoursesBatchIdTopicsTopicIdResourcesRouteImport
      parentRoute: typeof StudentCoursesBatchIdTopicsTopicIdRoute
    }
    '/_student/courses/$batchId/topics/$topicId/recording': {
      id: '/_student/courses/$batchId/topics/$topicId/recording'
      path: '/recording'
      fullPath: '/courses/$batchId/topics/$topicId/recording'
      preLoaderRoute: typeof StudentCoursesBatchIdTopicsTopicIdRecordingRouteImport
      parentRoute: typeof StudentCoursesBatchIdTopicsTopicIdRoute
    }
    '/_student/courses/$batchId/topics/$topicId/practice': {
      id: '/_student/courses/$batchId/topics/$topicId/practice'
      path: '/practice'
      fullPath: '/courses/$batchId/topics/$topicId/practice'
      preLoaderRoute: typeof StudentCoursesBatchIdTopicsTopicIdPracticeRouteImport
      parentRoute: typeof StudentCoursesBatchIdTopicsTopicIdRoute
    }
    '/_student/courses/$batchId/topics/$topicId/notes': {
      id: '/_student/courses/$batchId/topics/$topicId/notes'
      path: '/notes'
      fullPath: '/courses/$batchId/topics/$topicId/notes'
      preLoaderRoute: typeof StudentCoursesBatchIdTopicsTopicIdNotesRouteImport
      parentRoute: typeof StudentCoursesBatchIdTopicsTopicIdRoute
    }
    '/_student/courses/$batchId/topics/$topicId/feedback': {
      id: '/_student/courses/$batchId/topics/$topicId/feedback'
      path: '/feedback'
      fullPath: '/courses/$batchId/topics/$topicId/feedback'
      preLoaderRoute: typeof StudentCoursesBatchIdTopicsTopicIdFeedbackRouteImport
      parentRoute: typeof StudentCoursesBatchIdTopicsTopicIdRoute
    }
    '/_student/courses/$batchId/topics/$topicId/ask-trainer': {
      id: '/_student/courses/$batchId/topics/$topicId/ask-trainer'
      path: '/ask-trainer'
      fullPath: '/courses/$batchId/topics/$topicId/ask-trainer'
      preLoaderRoute: typeof StudentCoursesBatchIdTopicsTopicIdAskTrainerRouteImport
      parentRoute: typeof StudentCoursesBatchIdTopicsTopicIdRoute
    }
    '/_student/courses/$batchId/practice/$category/$assessmentId': {
      id: '/_student/courses/$batchId/practice/$category/$assessmentId'
      path: '/courses/$batchId/practice/$category/$assessmentId'
      fullPath: '/courses/$batchId/practice/$category/$assessmentId'
      preLoaderRoute: typeof StudentCoursesBatchIdPracticeCategoryAssessmentIdRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_student/courses/$batchId/topics/$topicId_/quiz/$assessmentId': {
      id: '/_student/courses/$batchId/topics/$topicId_/quiz/$assessmentId'
      path: '/courses/$batchId/topics/$topicId/quiz/$assessmentId'
      fullPath: '/courses/$batchId/topics/$topicId/quiz/$assessmentId'
      preLoaderRoute: typeof StudentCoursesBatchIdTopicsTopicIdQuizAssessmentIdRouteImport
      parentRoute: typeof StudentRoute
    }
  }
}

interface StudentCoursesBatchIdTopicsTopicIdRouteChildren {
  StudentCoursesBatchIdTopicsTopicIdAskTrainerRoute: typeof StudentCoursesBatchIdTopicsTopicIdAskTrainerRoute
  StudentCoursesBatchIdTopicsTopicIdFeedbackRoute: typeof StudentCoursesBatchIdTopicsTopicIdFeedbackRoute
  StudentCoursesBatchIdTopicsTopicIdNotesRoute: typeof StudentCoursesBatchIdTopicsTopicIdNotesRoute
  StudentCoursesBatchIdTopicsTopicIdPracticeRoute: typeof StudentCoursesBatchIdTopicsTopicIdPracticeRoute
  StudentCoursesBatchIdTopicsTopicIdRecordingRoute: typeof StudentCoursesBatchIdTopicsTopicIdRecordingRoute
  StudentCoursesBatchIdTopicsTopicIdResourcesRoute: typeof StudentCoursesBatchIdTopicsTopicIdResourcesRoute
  StudentCoursesBatchIdTopicsTopicIdIndexRoute: typeof StudentCoursesBatchIdTopicsTopicIdIndexRoute
}

const StudentCoursesBatchIdTopicsTopicIdRouteChildren: StudentCoursesBatchIdTopicsTopicIdRouteChildren =
  {
    StudentCoursesBatchIdTopicsTopicIdAskTrainerRoute:
      StudentCoursesBatchIdTopicsTopicIdAskTrainerRoute,
    StudentCoursesBatchIdTopicsTopicIdFeedbackRoute:
      StudentCoursesBatchIdTopicsTopicIdFeedbackRoute,
    StudentCoursesBatchIdTopicsTopicIdNotesRoute:
      StudentCoursesBatchIdTopicsTopicIdNotesRoute,
    StudentCoursesBatchIdTopicsTopicIdPracticeRoute:
      StudentCoursesBatchIdTopicsTopicIdPracticeRoute,
    StudentCoursesBatchIdTopicsTopicIdRecordingRoute:
      StudentCoursesBatchIdTopicsTopicIdRecordingRoute,
    StudentCoursesBatchIdTopicsTopicIdResourcesRoute:
      StudentCoursesBatchIdTopicsTopicIdResourcesRoute,
    StudentCoursesBatchIdTopicsTopicIdIndexRoute:
      StudentCoursesBatchIdTopicsTopicIdIndexRoute,
  }

const StudentCoursesBatchIdTopicsTopicIdRouteWithChildren =
  StudentCoursesBatchIdTopicsTopicIdRoute._addFileChildren(
    StudentCoursesBatchIdTopicsTopicIdRouteChildren,
  )

interface StudentRouteChildren {
  StudentHelpRoute: typeof StudentHelpRoute
  StudentSettingsRoute: typeof StudentSettingsRoute
  StudentHackathonsHackathonIdRoute: typeof StudentHackathonsHackathonIdRoute
  StudentProblemsSlugRoute: typeof StudentProblemsSlugRoute
  StudentContestsIndexRoute: typeof StudentContestsIndexRoute
  StudentCoursesIndexRoute: typeof StudentCoursesIndexRoute
  StudentHackathonsIndexRoute: typeof StudentHackathonsIndexRoute
  StudentLeaderboardIndexRoute: typeof StudentLeaderboardIndexRoute
  StudentProblemsIndexRoute: typeof StudentProblemsIndexRoute
  StudentProgressIndexRoute: typeof StudentProgressIndexRoute
  StudentScheduleIndexRoute: typeof StudentScheduleIndexRoute
  StudentCoursesBatchIdLearnRoute: typeof StudentCoursesBatchIdLearnRoute
  StudentCoursesBatchIdIndexRoute: typeof StudentCoursesBatchIdIndexRoute
  StudentCoursesBatchIdTopicsTopicIdRoute: typeof StudentCoursesBatchIdTopicsTopicIdRouteWithChildren
  StudentCoursesBatchIdPracticeIndexRoute: typeof StudentCoursesBatchIdPracticeIndexRoute
  StudentCoursesBatchIdPracticeCategoryAssessmentIdRoute: typeof StudentCoursesBatchIdPracticeCategoryAssessmentIdRoute
  StudentCoursesBatchIdPracticeCategoryIndexRoute: typeof StudentCoursesBatchIdPracticeCategoryIndexRoute
  StudentCoursesBatchIdTopicsTopicIdQuizAssessmentIdRoute: typeof StudentCoursesBatchIdTopicsTopicIdQuizAssessmentIdRoute
}

const StudentRouteChildren: StudentRouteChildren = {
  StudentHelpRoute: StudentHelpRoute,
  StudentSettingsRoute: StudentSettingsRoute,
  StudentHackathonsHackathonIdRoute: StudentHackathonsHackathonIdRoute,
  StudentProblemsSlugRoute: StudentProblemsSlugRoute,
  StudentContestsIndexRoute: StudentContestsIndexRoute,
  StudentCoursesIndexRoute: StudentCoursesIndexRoute,
  StudentHackathonsIndexRoute: StudentHackathonsIndexRoute,
  StudentLeaderboardIndexRoute: StudentLeaderboardIndexRoute,
  StudentProblemsIndexRoute: StudentProblemsIndexRoute,
  StudentProgressIndexRoute: StudentProgressIndexRoute,
  StudentScheduleIndexRoute: StudentScheduleIndexRoute,
  StudentCoursesBatchIdLearnRoute: StudentCoursesBatchIdLearnRoute,
  StudentCoursesBatchIdIndexRoute: StudentCoursesBatchIdIndexRoute,
  StudentCoursesBatchIdTopicsTopicIdRoute:
    StudentCoursesBatchIdTopicsTopicIdRouteWithChildren,
  StudentCoursesBatchIdPracticeIndexRoute:
    StudentCoursesBatchIdPracticeIndexRoute,
  StudentCoursesBatchIdPracticeCategoryAssessmentIdRoute:
    StudentCoursesBatchIdPracticeCategoryAssessmentIdRoute,
  StudentCoursesBatchIdPracticeCategoryIndexRoute:
    StudentCoursesBatchIdPracticeCategoryIndexRoute,
  StudentCoursesBatchIdTopicsTopicIdQuizAssessmentIdRoute:
    StudentCoursesBatchIdTopicsTopicIdQuizAssessmentIdRoute,
}

const StudentRouteWithChildren =
  StudentRoute._addFileChildren(StudentRouteChildren)

interface AdminBatchesBatchIdRouteChildren {
  AdminBatchesBatchIdCurriculumRoute: typeof AdminBatchesBatchIdCurriculumRoute
  AdminBatchesBatchIdEnrollmentRoute: typeof AdminBatchesBatchIdEnrollmentRoute
  AdminBatchesBatchIdIndexRoute: typeof AdminBatchesBatchIdIndexRoute
  AdminBatchesBatchIdHackathonsHackathonIdRoute: typeof AdminBatchesBatchIdHackathonsHackathonIdRoute
  AdminBatchesBatchIdHackathonsIndexRoute: typeof AdminBatchesBatchIdHackathonsIndexRoute
}

const AdminBatchesBatchIdRouteChildren: AdminBatchesBatchIdRouteChildren = {
  AdminBatchesBatchIdCurriculumRoute: AdminBatchesBatchIdCurriculumRoute,
  AdminBatchesBatchIdEnrollmentRoute: AdminBatchesBatchIdEnrollmentRoute,
  AdminBatchesBatchIdIndexRoute: AdminBatchesBatchIdIndexRoute,
  AdminBatchesBatchIdHackathonsHackathonIdRoute:
    AdminBatchesBatchIdHackathonsHackathonIdRoute,
  AdminBatchesBatchIdHackathonsIndexRoute:
    AdminBatchesBatchIdHackathonsIndexRoute,
}

const AdminBatchesBatchIdRouteWithChildren =
  AdminBatchesBatchIdRoute._addFileChildren(AdminBatchesBatchIdRouteChildren)

interface AdminRouteChildren {
  AdminAnalyticsRoute: typeof AdminAnalyticsRoute
  AdminDashboardRoute: typeof AdminDashboardRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminStudentFeedbackRoute: typeof AdminStudentFeedbackRoute
  AdminTrainerFeedbackRoute: typeof AdminTrainerFeedbackRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminBatchesBatchIdRoute: typeof AdminBatchesBatchIdRouteWithChildren
  AdminCurriculumTemplateIdRoute: typeof AdminCurriculumTemplateIdRoute
  AdminOrgsOrgIdRoute: typeof AdminOrgsOrgIdRoute
  AdminOrgsNewRoute: typeof AdminOrgsNewRoute
  AdminProblemsProblemIdRoute: typeof AdminProblemsProblemIdRoute
  AdminProblemsNewRoute: typeof AdminProblemsNewRoute
  AdminBatchesIndexRoute: typeof AdminBatchesIndexRoute
  AdminCurriculumIndexRoute: typeof AdminCurriculumIndexRoute
  AdminOrgsIndexRoute: typeof AdminOrgsIndexRoute
  AdminProblemsIndexRoute: typeof AdminProblemsIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAnalyticsRoute: AdminAnalyticsRoute,
  AdminDashboardRoute: AdminDashboardRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminStudentFeedbackRoute: AdminStudentFeedbackRoute,
  AdminTrainerFeedbackRoute: AdminTrainerFeedbackRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminBatchesBatchIdRoute: AdminBatchesBatchIdRouteWithChildren,
  AdminCurriculumTemplateIdRoute: AdminCurriculumTemplateIdRoute,
  AdminOrgsOrgIdRoute: AdminOrgsOrgIdRoute,
  AdminOrgsNewRoute: AdminOrgsNewRoute,
  AdminProblemsProblemIdRoute: AdminProblemsProblemIdRoute,
  AdminProblemsNewRoute: AdminProblemsNewRoute,
  AdminBatchesIndexRoute: AdminBatchesIndexRoute,
  AdminCurriculumIndexRoute: AdminCurriculumIndexRoute,
  AdminOrgsIndexRoute: AdminOrgsIndexRoute,
  AdminProblemsIndexRoute: AdminProblemsIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface OrgRouteChildren {
  OrgCompanyReadinessRoute: typeof OrgCompanyReadinessRoute
  OrgMessagesRoute: typeof OrgMessagesRoute
  OrgReadinessRoute: typeof OrgReadinessRoute
  OrgSettingsRoute: typeof OrgSettingsRoute
  OrgStudentsRoute: typeof OrgStudentsRoute
  OrgSupportRoute: typeof OrgSupportRoute
  OrgIndexRoute: typeof OrgIndexRoute
  OrgBatchesIndexRoute: typeof OrgBatchesIndexRoute
  OrgBatchesBatchIdIndexRoute: typeof OrgBatchesBatchIdIndexRoute
  OrgBatchesBatchIdAssessmentsAssessmentIdRoute: typeof OrgBatchesBatchIdAssessmentsAssessmentIdRoute
  OrgBatchesBatchIdAssignmentsAssignmentIdRoute: typeof OrgBatchesBatchIdAssignmentsAssignmentIdRoute
  OrgBatchesBatchIdSessionsSessionIdRoute: typeof OrgBatchesBatchIdSessionsSessionIdRoute
  OrgBatchesBatchIdStudentsUserIdRoute: typeof OrgBatchesBatchIdStudentsUserIdRoute
  OrgBatchesBatchIdWorkItemsAssessmentIdRoute: typeof OrgBatchesBatchIdWorkItemsAssessmentIdRoute
}

const OrgRouteChildren: OrgRouteChildren = {
  OrgCompanyReadinessRoute: OrgCompanyReadinessRoute,
  OrgMessagesRoute: OrgMessagesRoute,
  OrgReadinessRoute: OrgReadinessRoute,
  OrgSettingsRoute: OrgSettingsRoute,
  OrgStudentsRoute: OrgStudentsRoute,
  OrgSupportRoute: OrgSupportRoute,
  OrgIndexRoute: OrgIndexRoute,
  OrgBatchesIndexRoute: OrgBatchesIndexRoute,
  OrgBatchesBatchIdIndexRoute: OrgBatchesBatchIdIndexRoute,
  OrgBatchesBatchIdAssessmentsAssessmentIdRoute:
    OrgBatchesBatchIdAssessmentsAssessmentIdRoute,
  OrgBatchesBatchIdAssignmentsAssignmentIdRoute:
    OrgBatchesBatchIdAssignmentsAssignmentIdRoute,
  OrgBatchesBatchIdSessionsSessionIdRoute:
    OrgBatchesBatchIdSessionsSessionIdRoute,
  OrgBatchesBatchIdStudentsUserIdRoute: OrgBatchesBatchIdStudentsUserIdRoute,
  OrgBatchesBatchIdWorkItemsAssessmentIdRoute:
    OrgBatchesBatchIdWorkItemsAssessmentIdRoute,
}

const OrgRouteWithChildren = OrgRoute._addFileChildren(OrgRouteChildren)

interface TrainerBatchesBatchIdRouteChildren {
  TrainerBatchesBatchIdAnnouncementsRoute: typeof TrainerBatchesBatchIdAnnouncementsRoute
  TrainerBatchesBatchIdAttentionRoute: typeof TrainerBatchesBatchIdAttentionRoute
  TrainerBatchesBatchIdCurriculumRoute: typeof TrainerBatchesBatchIdCurriculumRoute
  TrainerBatchesBatchIdGradingRoute: typeof TrainerBatchesBatchIdGradingRoute
  TrainerBatchesBatchIdOverviewRoute: typeof TrainerBatchesBatchIdOverviewRoute
  TrainerBatchesBatchIdSessionsRoute: typeof TrainerBatchesBatchIdSessionsRoute
  TrainerBatchesBatchIdStudentsRoute: typeof TrainerBatchesBatchIdStudentsRoute
  TrainerBatchesBatchIdIndexRoute: typeof TrainerBatchesBatchIdIndexRoute
  TrainerBatchesBatchIdHackathonsHackathonIdRoute: typeof TrainerBatchesBatchIdHackathonsHackathonIdRoute
  TrainerBatchesBatchIdWorkItemsAssessmentIdRoute: typeof TrainerBatchesBatchIdWorkItemsAssessmentIdRoute
  TrainerBatchesBatchIdHackathonsIndexRoute: typeof TrainerBatchesBatchIdHackathonsIndexRoute
}

const TrainerBatchesBatchIdRouteChildren: TrainerBatchesBatchIdRouteChildren = {
  TrainerBatchesBatchIdAnnouncementsRoute:
    TrainerBatchesBatchIdAnnouncementsRoute,
  TrainerBatchesBatchIdAttentionRoute: TrainerBatchesBatchIdAttentionRoute,
  TrainerBatchesBatchIdCurriculumRoute: TrainerBatchesBatchIdCurriculumRoute,
  TrainerBatchesBatchIdGradingRoute: TrainerBatchesBatchIdGradingRoute,
  TrainerBatchesBatchIdOverviewRoute: TrainerBatchesBatchIdOverviewRoute,
  TrainerBatchesBatchIdSessionsRoute: TrainerBatchesBatchIdSessionsRoute,
  TrainerBatchesBatchIdStudentsRoute: TrainerBatchesBatchIdStudentsRoute,
  TrainerBatchesBatchIdIndexRoute: TrainerBatchesBatchIdIndexRoute,
  TrainerBatchesBatchIdHackathonsHackathonIdRoute:
    TrainerBatchesBatchIdHackathonsHackathonIdRoute,
  TrainerBatchesBatchIdWorkItemsAssessmentIdRoute:
    TrainerBatchesBatchIdWorkItemsAssessmentIdRoute,
  TrainerBatchesBatchIdHackathonsIndexRoute:
    TrainerBatchesBatchIdHackathonsIndexRoute,
}

const TrainerBatchesBatchIdRouteWithChildren =
  TrainerBatchesBatchIdRoute._addFileChildren(
    TrainerBatchesBatchIdRouteChildren,
  )

interface TrainerRouteChildren {
  TrainerAnalyticsRoute: typeof TrainerAnalyticsRoute
  TrainerDashboardRoute: typeof TrainerDashboardRoute
  TrainerQuestionsRoute: typeof TrainerQuestionsRoute
  TrainerSettingsRoute: typeof TrainerSettingsRoute
  TrainerIndexRoute: typeof TrainerIndexRoute
  TrainerBatchesBatchIdRoute: typeof TrainerBatchesBatchIdRouteWithChildren
  TrainerProblemsProblemIdRoute: typeof TrainerProblemsProblemIdRoute
  TrainerProblemsNewRoute: typeof TrainerProblemsNewRoute
  TrainerBatchesIndexRoute: typeof TrainerBatchesIndexRoute
  TrainerProblemsIndexRoute: typeof TrainerProblemsIndexRoute
}

const TrainerRouteChildren: TrainerRouteChildren = {
  TrainerAnalyticsRoute: TrainerAnalyticsRoute,
  TrainerDashboardRoute: TrainerDashboardRoute,
  TrainerQuestionsRoute: TrainerQuestionsRoute,
  TrainerSettingsRoute: TrainerSettingsRoute,
  TrainerIndexRoute: TrainerIndexRoute,
  TrainerBatchesBatchIdRoute: TrainerBatchesBatchIdRouteWithChildren,
  TrainerProblemsProblemIdRoute: TrainerProblemsProblemIdRoute,
  TrainerProblemsNewRoute: TrainerProblemsNewRoute,
  TrainerBatchesIndexRoute: TrainerBatchesIndexRoute,
  TrainerProblemsIndexRoute: TrainerProblemsIndexRoute,
}

const TrainerRouteWithChildren =
  TrainerRoute._addFileChildren(TrainerRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  StudentRoute: StudentRouteWithChildren,
  AdminRoute: AdminRouteWithChildren,
  LoginRoute: LoginRoute,
  OrgRoute: OrgRouteWithChildren,
  TrainerRoute: TrainerRouteWithChildren,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthOauthCallbackRoute: AuthOauthCallbackRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSetupRoute: AuthSetupRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  MessagesIndexRoute: MessagesIndexRoute,
  ProfileIndexRoute: ProfileIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
